import template from './ecocode-trustpilot-invitation-template-select.twig';

const {object} = Shopware.Utils;

Shopware.Component.register('ecocode-trustpilot-invitation-template-select', {
    inject: ['ecocodeTrustpilotConfigurationService'],
    emits: ['update:value'],
    inheritAttrs: false,
    template,
    props: {
        businessUnit: {
            type: String
        },
        locale: {
            type: String
        },
        type: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false
        }
    },
    computed: {
        options() {
            if (!this.templates) {
                return [];
            }

            const options = [];
            Object.entries(this.templates).forEach(([locale, localeTemplates]) => {
                // compare lang part of locale to fetch en-US - en-GB templates
                // also add generic templates without locale associated
                if (!locale || locale.substring(0, 2) === this.locale.substring(0, 2)) {
                    localeTemplates.forEach((template) => {
                        const name = template.locale ? `${template.locale} - ${template.type}` : `${template.type}`
                        options.push({
                            label: `${template.name} (${name})`,
                            value: template.id
                        });
                    });
                }
            });
            return options;
        }
    },
    methods: {
        async loadTemplates() {
            this.isLoading = true;
            const data = await this.ecocodeTrustpilotConfigurationService.getTemplateConfiguration(this.businessUnit, this.type);
            if (data.status === 'not_connected') {
                this.$router.push({name: 'ecocode.trustpilot.setup.welcome'});
            }

            this.templates = data.templates;
            this.isLoading = false;
        },
        validateTemplate() {
            const currentTemplate = this.options.find(option => option.value === this.currentValue)
            // unset root value if current value is not available in templates list
            if(this.currentValue && !currentTemplate){
                this.$emit('update:value', null)
            }
        }
    },
    async mounted() {
        await this.loadTemplates()

        if (this.value) {
            this.currentValue = object.cloneDeep(this.value)
        }
    },
    watch: {
        currentValue(newValue) {
            if(newValue !== this.value) {
                this.$emit('update:value', object.cloneDeep(newValue))
            }
        },
        businessUnit(newValue) {
            this.loadTemplates().then(()=> {
                // validate current value on templates refresh
                this.validateTemplate()
            })
        }
    },

    data() {
        return {
            templates: [],
            currentValue: null
        };
    }
});
